import { render, staticRenderFns } from "./TaskFinishedModal.vue?vue&type=template&id=c059abd0&scoped=true&"
import script from "./TaskFinishedModal.vue?vue&type=script&lang=ts&"
export * from "./TaskFinishedModal.vue?vue&type=script&lang=ts&"
import style0 from "./TaskFinishedModal.vue?vue&type=style&index=0&id=c059abd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c059abd0",
  null
  
)

export default component.exports